webpackJsonp([114276838955818,60335399758886],{

/***/ 128:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(266);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(128);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIxODUuN3B4IiBoZWlnaHQ9IjI0Ny45cHgiIHZpZXdCb3g9IjAgMCAxODUuNyAyNDcuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTg1LjcgMjQ3Ljk7IiB4bWw6c3BhY2U9InByZXNlcnZlIgoJPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtkaXNwbGF5Om5vbmU7b3BhY2l0eTowLjI1O30KCS5zdDF7ZGlzcGxheTppbmxpbmU7fQoJLnN0MntmaWxsOiMzMTMwMzE7fQo8L3N0eWxlPgo8ZyBjbGFzcz0ic3QwIj4KCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00NDAuMyw0Ni43bDQ5LTE4LjdsODksMjdsMC43LDI4Ljd2MTMuN2w3LjctNC43bDMsNi4zbDEuMywxMWMwLDAtMi44LDEwLjQtNi4zLDEwLjcKCQljLTMuNiwwLjItNi43LTIuMy02LjctMi4zbC0xLDQ3LjdsLTE0LjcsMjAuN2wtNDEuMyw0NWwtMzkuMy02bC0yNi4zLTMxLjNsLTE3LjMtMjBsMS42LTUwLjJsLTQuOSwxLjlsLTYtNi4zbC0xLjctNy4zbDQtMTUuNwoJCWwzLjMsMmg0LjdsMS4zLTExLjdsMC4zLTIxTDQ0MC4zLDQ2Ljd6Ii8+CjwvZz4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QyIiBkPSJNNDkuOSwxMTQuOGMtMi4yLDAtNCwwLjUtNC4xLDIuN2MwLDIuMiwxLjcsNCw0LDQuMWMyLjIsMCw0LTEuNyw0LjEtNEM1My45LDExNS40LDUyLjIsMTE0LjksNDkuOSwxMTQuOHoiLz4KCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xMjIuNiwxMTQuMmMtMi4xLDAtMy42LDIuOS0zLjYsNWMwLDIuMiwyLjgsMy4xLDQuOSwzLjFzMy44LTEuNywzLjktMy45CgkJQzEyNy44LDExNi4zLDEyNC43LDExNC4yLDEyMi42LDExNC4yeiIvPgoJPHBhdGggY2xhc3M9InN0MiIgZD0iTTY3LjUsOTYuM2wtMzEuOSwyLjJjLTEuMywwLTIuNCwxLjgtMi40LDMuMWMwLDEuMywxLDEuNywyLjMsMS43bDMxLjIsMC4yYzAuMSwwLDAuMSwwLDAuMiwwCgkJYzEuMy0wLjEsMi4zLTEuMSwyLjMtMi40QzY5LjIsOTkuOSw2OC44LDk2LjMsNjcuNSw5Ni4zeiIvPgoJPHBhdGggY2xhc3M9InN0MiIgZD0iTTE4Mi4zLDQxLjFjLTMsNi4yLTEyLjgsNi4xLTEyLjgsNi4xcy0wLjMtMC42LTAuNi0xLjJjMCwwLDYuMi0zLjUsNS43LTkuNWMtMi42LDMuNi04LjcsNC0xMCwyLjMKCQlDMTUwLjMsMTkuNCwxMjEuMy0xMS44LDczLjQsMTVjMC4xLTEuMywwLjItNS4xLDcuMS02LjVjMC4zLTAuMSwwLjMtMi4zLDAuMy0yLjVjLTAuMS0wLjMtMi0wLjktMi4yLTAuOWMtNi4zLDEuMy02LjcsNS45LTcuMSw4LjMKCQljLTAuOC0xLjUtMS4zLTMuNCwxLjMtNi42YzAuMi0wLjItMC40LTEuNC0wLjYtMS42Yy0wLjMtMC40LTMuNSwwLjItMy42LDAuNGMtMy4xLDMuOCwxLjQsNy41LDIuNSw5LjNDMTYuMS04LjcsMTAuNSw0OSwxMC41LDQ5CgkJczAuOCwwLjEsMS42LDAuOGMwLjQsMC4zLDEuNCwyMi43LDEuOCw0My4yYy0xLjUtMC40LTIuOS0wLjQtNC4xLDAuNGMtNC4xLDIuOS03LDIxLjYtNC41LDI5LjRjMi40LDcuOCw3LjYsMTEuNCwxMSwxMS42CgkJYzAuMSwwLDAuMSwwLDAuMiwwYzAuNCwwLDAuOC0wLjEsMS4yLTAuMmMtMC41LDI3LTEuMyw1MS0wLjQsNTIuOWMwLjEsMC4yLDAuMywwLjYsMC43LDEuMWMwLjIsMC4zLDIuOC0zLjksMy4xLTMuNAoJCWMwLjMsMC41LTAuNSw2LjktMC4xLDcuNWMxMCwxMy4yLDQxLjgsNDcuMSw0OC4xLDQ4LjRjMC43LDAuMiwxLjcsMC4yLDIuOCwwLjNjMC45LDAsMS42LTYuOSwyLjctNi45YzAuNSwwLDQuMSw2LjUsNC41LDYuNQoJCWMxMS40LTAuOCwyNy40LTQuMywzMC44LTUuNmMzLjgtMS40LDM0LTM5LjcsNDEuOS01MS43YzAuMy0wLjUtMS42LTYuNS0xLjQtNi44YzAuNC0wLjYsMy45LDIuOCw0LDIuNmMwLDAsMC0wLjEsMC4xLTAuMgoJCWMwLjctMi42LDEuNy0yMi40LDIuOC00NC44YzAuNCwwLjEsMC44LDAuMiwxLjIsMC4yYzAsMCwwLjEsMCwwLjIsMGMzLjMtMC4xLDcuOS0zLjUsMTAuNS0xMS4xczEuNS0yNi0yLjQtMjguOQoJCWMtMS4yLTAuOS0yLjgtMC45LTQuNC0wLjVjMS40LTE3LjQsMy40LTMxLjUsNC0zMS43QzE3My43LDU3LjMsMTc5LjQsNTMuNiwxODIuMyw0MS4xeiBNMTYuNSwxMzAuNUwxNi41LDEzMC41CgkJYy0xLjEtMC4xLTQuNi0xLjgtNi45LTguOWMtMi4yLTcuMSwwLjgtMjIuMiwyLjgtMjMuN2MwLjctMC41LDMsMC41LDUuNCwyLjFjMCwxLjEsMCwyLjMsMCwzLjRjLTAuNy0wLjEtMS40LDAtMiwwLjMKCQljLTMuMywxLjUtMy45LDcuNC0xLjksMTkuMmMwLjEsMC43LDAuNywxLjIsMS40LDEuMmMwLjEsMCwwLjIsMCwwLjMsMGMwLjgtMC4xLDEuMy0wLjksMS4yLTEuNmMtMi40LTE0LjItMC4xLTE2LDAuMy0xNi4yCgkJYzAuMi0wLjEsMC41LTAuMSwwLjgsMGMwLDIuNSwwLDUsMCw3LjZjMCw1LjMtMC4xLDEwLjctMC4yLDE1LjlDMTcuMywxMzAuMiwxNi44LDEzMC41LDE2LjUsMTMwLjV6IE0xMTYuNCwyMDkuNAoJCWMtMS4yLDEuNC0xMC42LDQuMy0xNi4yLDUuNGMwLDAsMi0xOC43LTQuNS0xNy4zYzAsMC02LjYsMi40LTgsMi40cy02LjUtMS45LTYuNS0xLjljLTcuOC0wLjgtNS42LDE2LjUtNS42LDE2LjUKCQljLTUuNy0xLjMtMTUuNS00LjktMTYuMS01LjlzLTAuOS0yMC41LTAuOS0yMC41bDI3LjIsMy4yYzAsMCwxLTMuMywxLjYtMy41czEuOCwzLjEsMS44LDMuMWwyNy42LTYuOGMwLDAsMi41LDkuMiwyLjYsMTEuOAoJCUMxMTkuNCwxOTguNSwxMTcuNiwyMDgsMTE2LjQsMjA5LjR6IE0xNDkuMSwxMTcuNGMwLDEtNi4xLDQ1LjctNy4zLDQ4Yy0xLjIsMi4zLTIzLjQsMTMuOS0yMy40LDEzLjljLTUuNC02LjktMTkuMy0yLjUtMTkuMy0yLjUKCQljMC43LTAuNCwxLjUtMSwyLjItMS43YzIuNy0yLjcsMi4zLTksMS0xMi4zYy0xLjUtMy43LTMuOS00LjMtNS4yLTQuM2MtNS4zLTAuMS02LjYsMi42LTcuMSwzLjRjLTEuNywzLjEsMi42LDMuOSw0LjMsMi4zCgkJYzAuOS0wLjcsMS43LTAuOCwyLjctMC44YzAuMiwwLjEsMC45LDEsMS4zLDIuOWMwLjUsMi43LDAsNC45LTAuMyw1LjRjLTAuNywwLjctMS41LDEuMS0yLjEsMS4zYzAtMC4yLDAtMC40LDAtMC42CgkJYzAtMS4zLTEuMS0yLjQtMi40LTIuNWMtMS4zLDAtMi40LDEuMS0yLjUsMi40YzAsMi4zLTEuOSw0LjEtNC4yLDQuMXMtNC4xLTEuOS00LjEtNC4yYzAtMS4zLTEuMS0yLjQtMi40LTIuNQoJCWMtMS4zLDAtMi40LDEuMS0yLjUsMi40YzAsMC4xLDAsMC4xLDAsMC4yYy0wLjctMC4zLTEuNC0wLjYtMS44LTEuMWMtMC4zLTAuMy0wLjctMS43LTAuNi0zLjZjMC4xLTIsMC43LTMuNSwxLjMtNAoJCWMwLjUtMC41LDMsMC4xLDQuOSwxLjNjMC43LDAuNSwxLjcsMC41LDIuNCwwLjFjMC44LTAuNCwxLjMtMS4yLDEuMy0yLjFsMC42LTM2LjNsMS44LTI1LjVjMC4xLTEuMy0xLjktMi0zLjItMgoJCWMtMC45LTAuMS0xLjYsMC41LTEuNiwxLjhsLTEuOCwyNS40bC0wLjQsMzIuOGMtMi4zLTAuNy01LjItMS03LjMsMWMtMi4yLDIuMi0yLjcsNS44LTIuOCw3LjNjLTAuMSwxLjUsMCw1LjEsMiw3LjIKCQljMS4zLDEuMywyLjksMi4xLDQuMywyLjVjMCwwLTE3LjgtNi43LTIyLjMsMy45YzAsMCwwLjMtMS4xLTEuNC0zYy0xLjgtMi0yMS4zLTUuNi0yMi40LThzLTMuMS00Ni4xLTMuMS00Ni45CgkJYy0xLjIsMS41LTUuMS0xLjUtNS4yLTIuMWMwLTAuNSw0LjQsMC4yLDUuNi0yLjdjLTIuNCwwLTYtMC41LTUuOS0wLjlzNS40LTEuNSw1LjUtMy42YzAtMC42LDAuNS01NC42LDAuNS01NC42CgkJYzEwLjQsMS44LDIxLjUtMC41LDM2LTE1LjJjMjUuOCwyMC42LDYwLjYsMjksODcuNSwyMy4ybC0xLjgsNDBjMCwwLjcsNC45LDIuNyw0LDMuM2MtMSwwLjctMi44LDEuNS0zLjcsMS4yCgkJYy0wLjIsMS43LDQuMiwxLjQsNC4yLDEuN0MxNTQuMywxMTQsMTUwLjUsMTE4LjIsMTQ5LjEsMTE3LjR6IE0xNjMuNSw5OC41YzEuOSwxLjUsNC41LDE2LjQsMi4xLDIzLjNjLTIuNCw2LjktNS45LDguNS03LDguNWwwLDAKCQljLTAuMiwwLTAuNi0wLjEtMS4xLTAuM2MwLjMtNS44LDAuNi0xMS43LDAuOS0xNy40YzAuMS0xLjgsMC4yLTMuNiwwLjMtNS40YzAuOC0wLjYsMS41LTAuOCwxLjktMC42YzAuNCwwLjIsMiwyLjItMC45LDE2LjUKCQljLTAuMSwwLjgsMC4yLDEuNSwwLjgsMS43YzAuMSwwLDAuMiwwLDAuMywwYzAuNSwwLDEtMC40LDEuMS0xLjFjMi4zLTExLjksMi4zLTE4LTAuMi0xOS43Yy0wLjgtMC42LTEuOC0wLjUtMi44LTAuMQoJCWMwLjEtMS41LDAuMi0zLDAuMy00LjVDMTYxLjIsOTguNiwxNjIuOSw5OC4xLDE2My41LDk4LjV6Ii8+CjwvZz4KPHBhdGggY2xhc3M9InN0MiIgZD0iTTE0Mi44LDk4LjFjLTIuMi0xLjUtMTIuNS05LjQtMTguNy05LjRzLTE5LDcuOS0yMC41LDguOGMtMSwwLjYtMS40LDItMC43LDNjMC40LDAuNywzLjIsNCw0LjMsMy4zCgljNS41LTMuMywxMi4xLTEwLjgsMTYuOC0xMC44YzQuNywwLDExLjUsNC44LDE2LjEsOC4xYzEsMC43LDMuMSwwLjEsMy44LTAuOUMxNDQuNiw5OS4yLDE0My44LDk4LjgsMTQyLjgsOTguMUwxNDIuOCw5OC4xeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(123);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(23);
	
	var _profilePic = __webpack_require__(68);
	
	var _profilePic2 = _interopRequireDefault(_profilePic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginLeft: 'auto',
	          marginRight: 'auto',
	          maxWidth: (0, _typography.rhythm)(24),
	          padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4)
	        }
	      },
	      _react2.default.createElement('img', {
	        src: _profilePic2.default,
	        alt: 'Jordan Wade',
	        style: {
	          marginRight: (0, _typography.rhythm)(1 / 2),
	          marginBottom: 0,
	          width: (0, _typography.rhythm)(2),
	          height: (0, _typography.rhythm)(2)
	        }
	      })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f98a1f414f500f91ccd3.js